/**
 * author andre.pitombeira
 */
export default function RedemptionsController($timeout, $scope, RedemptionService, UtilService, OPTIONS, countryService) {
  var redemptions = this;

  redemptions.redemptions = [];

  redemptions.maxSize = 5;
  redemptions.currentPage = 1;
  redemptions.isLoading = false;
  redemptions.totalItems = 0;

  redemptions.options = {};

  redemptions.options.countries = [];
  redemptions.options.statuses = OPTIONS.statuses.redemptions;

  redemptions.filter = {
    country: null,
    status: null,
    query: '',
    reference: '',
    offset: 0,
    limit: 10,
  };

  redemptions.init = function() {
    getCountries();
  };

  function getCountries() {
    redemptions.isLoading = true;
    countryService
      .getAllCountries()
      .then(function(res) {
        if (res && res.data) {
          redemptions.options.countries = res.data;
        }
      })
      .finally(function() {
        redemptions.isLoading = false;
        redemptions.searchRedemptions();
      });
  }

  redemptions.searchRedemptions = function(resetPagination) {
    var searchUrl;

    if (redemptions.isLoading) {
      return;
    }

    redemptions.isLoading = true;

    if (resetPagination) {
      redemptions.calculatePagination();
    }

    searchUrl = UtilService.generateSearchUrl(redemptions.filter);

    RedemptionService.searchRedemptions(searchUrl)
      .then(function(res) {
        redemptions.setRedemptions(res.data);
        redemptions.totalItems = res.data.total;
      })
      .finally(function() {
        redemptions.currentPage = resetPagination ? 1 : redemptions.currentPage;
        redemptions.isLoading = false;
      });
  };

  redemptions.setRedemptions = function(data) {
    if (!(data && data.redemptions)) {
      return;
    }

    redemptions.redemptions = data.redemptions;
    redemptions.rowCollection = [].concat(redemptions.redemptions);
  };

  redemptions.pageChanged = function() {
    redemptions.calculatePagination();
    redemptions.searchRedemptions();
  };

  redemptions.calculatePagination = function() {
    redemptions.filter.offset = redemptions.currentPage * redemptions.filter.limit - redemptions.filter.limit;
  };

  $scope.$on('redemption-edit-controller.refresh-redemption-list', function() {
    redemptions.searchRedemptions();
  });

  redemptions.init();
}



// WEBPACK FOOTER //
// ./src/app/redemptions/redemptions.controller.js